import { EvaluationRange, InsightMetric } from '@repo/types';
import { Card, Typography } from 'components';
import { TinyAIPromptEntryPoint } from 'components/TinyAI/TinyAIPromptEntryPoint';
import { userValueFormat } from 'helpers';
import Markdown from 'markdown-to-jsx';
import { ReactNode } from 'react';
import { RangesGraph } from '../../RangesGraph/RangesGraph';
import { EvaluationPillFromColor } from '../SubMetricGraphs';
import styles from './ResultCard.module.css';

interface ResultCardProps {
  metric: Partial<InsightMetric>;
  ranges?: EvaluationRange[];
  subtitle?: ReactNode;
  headline?: ReactNode;
}

export default function ResultCard({
  metric,
  ranges,
  subtitle,
  headline,
}: ResultCardProps) {
  const formattedValue = userValueFormat(
    metric?.user_value ?? 0,
    metric?.data_type ?? 'percent',
    metric?.user_string ?? '',
  );
  const unit = metric?.gut_vaginal_health?.unit;
  const withUnitValue = `${formattedValue}${unit ? ` ${unit}` : ''}`;

  const metricDetectedText = metric.detected_text;

  return (
    <Card>
      <div className={styles.container}>
        <Typography variant={'heading-m'}>Your Result</Typography>
        <div className={styles.resultWrapper}>
          <div className={styles.textsContainer}>
            {headline ?? (
              <Typography variant={'heading-2xl'}>{withUnitValue}</Typography>
            )}

            {subtitle && (
              <Typography variant='body-s' color='grey'>
                {subtitle}
              </Typography>
            )}
          </div>
          <div className={styles.pillWrapper}>
            <EvaluationPillFromColor
              evaluation_color={metric.evaluation_color ?? 'grey'}
            />
          </div>
        </div>
        {metric.data_type !== 'string' && !!metric.range_bar_display && (
          <div className={styles.rangesGraphWrapper}>
            <RangesGraph
              dataType={metric.data_type}
              relativeAbundance={metric.user_value}
              ranges={ranges ?? metric.gut_vaginal_health_version_ranges}
              scaleBarMin={metric.scale_bar_min}
              scaleBarMax={metric.scale_bar_max}
              evaluationColor={metric.evaluation_color}
            />
          </div>
        )}
        {!!metricDetectedText ? (
          <div className={styles.whatThisMeans}>
            <Typography variant='body-xs' color='grey'>
              What this means
            </Typography>
            <Typography variant='body-s'>
              <Markdown>{metricDetectedText}</Markdown>
            </Typography>
          </div>
        ) : null}
        <TinyAIPromptEntryPoint
          location='metric_chatbot'
          variant='inline'
          metricName={metric.name}
        />
      </div>
    </Card>
  );
}
